import validation from '../../../../../modules/Gull/Framework/validation.js';

const verkort = {

	init() {

		// Verkrijg stap nummer uit navigatie tabs
		var stap = $('.nav-tabs').data('stap');

		// Initialiseer stappen
		verkort.initProgressBar();

		// Toon de introductie modal in stap 1 en fade de content in
		verkort.initContent(stap);

		// Javascript t.b.v. stap 4
		verkort.initSubmit(stap);

	},

	// Functie om de stappen te initialiseren
	initProgressBar: function() {

		// Nummer de stappen op basis van aanwezig aantal tabs
		$('.nav-tabs li a b.step-number').each(function(i) {
			$(this).text(i + 1);
		});

		// Tel totaal aantal tabs (stappen) en bereken de breedte van de tabs
		var stepsTotal = $('.sw-main ul.nav-tabs li').length;
		$('.sw-main ul.nav-tabs li').css('width', 'calc((100%)/' + stepsTotal + ')');

		// Fade de tabs in
		$('.sw-main').hide().removeClass('d-none').fadeIn(300);

	},

	// Toon de introductie modal in stap 1 en fade de content in
	initContent: function(stap) {
		$('.tab-content').hide().removeClass('d-none').fadeIn(300);
		if (stap == 1) {
			$('.modal-naverrekening-introductie').modal('show');
		}
	},

	// Initialiseer de submit functies
	initSubmit: function(stap) {
		if (stap == 4) {
			// Unbind de submit, toon de bevestigingsmodal en bind submit aan de submit modal
			$('form[data-validate]').attr('data-validate-onsubmit-disabled', true);
			$('form[data-validate]').submit(async function() {
				let validated = await validation.checkSubmitForm(this);
				if (validated) {
					$('.modal-naverrekening-indienen').modal('show');
					$('.btn-definitief-indienen').click(function() {
						$('form[data-validate]').unbind('submit');
						$('form[data-validate]').submit();
						$('#loadingModal').modal('show', {
							keyboard: false,
							backdrop: 'static'
						});
					});
				}
				return false;
			});
		}
	}

};

export default verkort;
